(function(){


  // window.testAlert = function () {
 	window.testerAlert = function () {

    console.log('alertt!')
    alert('alertt!')
  };
})();



// WEBPACK FOOTER //
// ./src/assets/alert.js